import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Bonus = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Bonus Paris Sportifs 2025</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <section>
            <p className="text-gray-700 text-lg leading-relaxed">
              Les <strong>bonus de bienvenue</strong> sont des offres proposées par les bookmakers pour 
              attirer de nouveaux joueurs. Découvrez comment fonctionnent ces bonus et comment en profiter 
              au maximum.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Types de bonus disponibles</h2>
            
            <div className="space-y-4">
              <div className="border-l-4 border-blue-500 pl-4">
                <h3 className="font-semibold text-lg text-gray-900">Pari gratuit (Freebet)</h3>
                <p className="text-gray-600 mt-1">
                  Le bookmaker vous offre un pari gratuit. Si vous gagnez, vous conservez les gains 
                  (hors mise). C'est le bonus le plus courant en France.
                </p>
              </div>
              
              <div className="border-l-4 border-green-500 pl-4">
                <h3 className="font-semibold text-lg text-gray-900">Premier pari remboursé</h3>
                <p className="text-gray-600 mt-1">
                  Votre premier pari est remboursé en cas de perte, généralement sous forme de freebet. 
                  Offre jusqu'à 100€ ou 150€ selon les opérateurs.
                </p>
              </div>
              
              <div className="border-l-4 border-purple-500 pl-4">
                <h3 className="font-semibold text-lg text-gray-900">Bonus sans dépôt</h3>
                <p className="text-gray-600 mt-1">
                  Rare mais très attractif : un bonus offert à l'inscription sans avoir à déposer. 
                  ParionsWeb (FDJ) propose 15€ offerts sans dépôt.
                </p>
              </div>
              
              <div className="border-l-4 border-orange-500 pl-4">
                <h3 className="font-semibold text-lg text-gray-900">Bonus sur dépôt</h3>
                <p className="text-gray-600 mt-1">
                  Un pourcentage de votre dépôt est ajouté en bonus (ex: 100% jusqu'à 100€). 
                  Souvent soumis à des conditions de mise.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Top bonus du moment</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-3 font-semibold">Bookmaker</th>
                    <th className="p-3 font-semibold">Bonus</th>
                    <th className="p-3 font-semibold">Type</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  <tr>
                    <td className="p-3">PMU</td>
                    <td className="p-3 font-medium text-green-600">150€ de paris gratuits</td>
                    <td className="p-3">Freebet</td>
                  </tr>
                  <tr>
                    <td className="p-3">Bwin</td>
                    <td className="p-3 font-medium text-green-600">120€ de bonus</td>
                    <td className="p-3">Premier pari remboursé</td>
                  </tr>
                  <tr>
                    <td className="p-3">Winamax</td>
                    <td className="p-3 font-medium text-green-600">100€ de paris gratuits</td>
                    <td className="p-3">Freebet</td>
                  </tr>
                  <tr>
                    <td className="p-3">Betclic</td>
                    <td className="p-3 font-medium text-green-600">100€ remboursés</td>
                    <td className="p-3">Premier pari remboursé</td>
                  </tr>
                  <tr>
                    <td className="p-3">ParionsWeb</td>
                    <td className="p-3 font-medium text-green-600">15€ sans dépôt + 100€</td>
                    <td className="p-3">Sans dépôt + Freebet</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Conditions des bonus</h2>
            <p className="text-gray-700 mb-4">
              Avant de réclamer un bonus, lisez attentivement les conditions générales :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Conditions de mise :</strong> Nombre de fois où le bonus doit être joué</li>
              <li><strong>Cote minimum :</strong> Souvent 1.50 ou plus pour les freebets</li>
              <li><strong>Durée de validité :</strong> Les bonus expirent généralement sous 7 à 30 jours</li>
              <li><strong>Sports éligibles :</strong> Certains bonus excluent des sports ou compétitions</li>
              <li><strong>Un seul bonus par personne :</strong> Les opérateurs vérifient les doublons</li>
            </ul>
          </section>

          <section className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-blue-800 mb-3">Conseil 123pariez</h2>
            <p className="text-blue-700">
              Ne choisissez pas un bookmaker uniquement pour son bonus. La qualité des cotes, 
              l'interface et le service client sont tout aussi importants pour votre expérience 
              de pari à long terme.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Bonus;
